module.exports = __webpack_public_path__ + "static/media/t11.634e2549.jpg";